import React from "react"
import types from "prop-types"
import { isEmpty } from "lodash-es"
import { useSelector } from "react-redux"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import Answer from "./Answer"

const MultiEntryAnswer = ({ rawAnswer = [] }) => {
  const clockFormat = useSelector(getClockFormat)

  if (isEmpty(rawAnswer)) {
    return (
      <Answer />
    )
  }

  return (
    rawAnswer.map((entry) => {
      const {
        answer, created_at: createdAt, user, uuid,
      } = entry

      return (
        <div className="answer mb-3 lg:p-3 pb-6 last:pb-0 lg:last:pb-3" key={`multi-entry-${uuid}`}>
          <div className="flex">
            <span className="grow mr-4 font-semibold text-sm break-anywhere">
              {user?.fullName}
            </span>
            <span className="shrink-0 text-xs lg:text-sm text-primary-300">
              {orgLocalDateTimeByClockFormat(createdAt, clockFormat)}
            </span>
          </div>
          <div className="whitespace-pre-wrap break-anywhere">
            {answer}
          </div>
        </div>
      )
    })
  )
}

MultiEntryAnswer.propTypes = {
  rawAnswer: types.array,
}

export default MultiEntryAnswer
